import React from 'react';

function About() {
  return (
    <div className="max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-8 text-center">About Us</h1>
      
      <div className="space-y-8">
        <section className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">Our Vision</h2>
          <p className="text-gray-300 leading-relaxed">
            We strive to make AI technology accessible to everyone, empowering creators to transform their ideas into stunning artwork with ease and speed.
          </p>
        </section>

        <section className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">Technology Used</h2>
          <p className="text-gray-300 leading-relaxed mb-4">
            We use the latest AI technology from Leonardo.ai to generate high-quality images. This technology enables us to:
          </p>
          <ul className="list-disc list-inside text-gray-300 space-y-2">
            <li>Generate unique and distinctive images</li>
            <li>Support a variety of artistic styles</li>
            <li>Provide high-quality images</li>
            <li>Fast generation and response times</li>
          </ul>
        </section>

        <section className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">Website Features</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="p-4 bg-gray-700 rounded">
              <h3 className="font-semibold mb-2">User-Friendly Interface</h3>
              <p className="text-gray-300">Simple and clear design that makes it easy for users to navigate the website</p>
            </div>
            <div className="p-4 bg-gray-700 rounded">
              <h3 className="font-semibold mb-2">Multiple Options</h3>
              <p className="text-gray-300">Ability to choose appropriate sizes and styles for images</p>
            </div>
            <div className="p-4 bg-gray-700 rounded">
              <h3 className="font-semibold mb-2">Image Gallery</h3>
              <p className="text-gray-300">A place to save and display generated images</p>
            </div>
            <div className="p-4 bg-gray-700 rounded">
              <h3 className="font-semibold mb-2">Image Sharing</h3>
              <p className="text-gray-300">Ability to share generated images with others</p>
            </div>
          </div>
        </section>

        <section className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">Privacy & Security</h2>
          <p className="text-gray-300 leading-relaxed">
            We take your privacy seriously. All generated images belong to the user, and we do not store or share any personal data.
          </p>
        </section>

        <section className="bg-gray-800 p-6 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">Contact Us</h2>
          <p className="text-gray-300 leading-relaxed">
            We welcome your feedback and suggestions. You can contact us through the Help page or send an email to:
            <br />
            <a href="mailto:support@aiartgenerator.com" className="text-blue-400 hover:text-blue-300">
              support@aiartgenerator.com
            </a>
          </p>
        </section>
      </div>
    </div>
  );
}

export default About; 